import { useState } from "react";
import { toast } from "sonner";
import { CheckCircle2, Loader2 } from "lucide-react";
import { Input } from "../../../components/ui/input";
import { errMsg } from "../../../lib/api";

export function StartStep({ st, pid, api, onAdded }) {
  const [host, setHost] = useState("");
  const [found, setFound] = useState(null);
  const [prov, setProv] = useState("");
  const [busy, setBusy] = useState(false);
  const run = async (fn) => { setBusy(true); try { await fn(); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); } };
  const check = () => run(async () => { const r = await api.post(`/projects/${pid}/domain/check-availability`, { hostname: host }); setFound(r.data); setProv(r.data.provider); });
  const add = () => run(async () => { const r = await api.post(`/projects/${pid}/domain`, { hostname: found.hostname, provider: prov }); onAdded(r.data); toast.success("Domain added. Now follow the steps shown."); });
  return (
    <div className="space-y-4" data-testid="domain-start">
      <div>
        <p className="font-semibold text-[#062a20]">1. Enter the domain you bought</p>
        <p className="text-xs text-slate-500">For example example.com or www.example.com</p>
        <div className="flex flex-wrap gap-2 mt-2">
          <Input value={host} onChange={(e) => { setHost(e.target.value); setFound(null); }} onKeyDown={(e) => e.key === "Enter" && host.trim() && check()} placeholder="example.com" className="h-11 flex-1 min-w-[200px]" data-testid="domain-input" />
          <button disabled={busy || !host.trim()} onClick={check} className="btn-gold !py-2.5" data-testid="domain-check-availability">{busy && !found && <Loader2 className="w-4 h-4 animate-spin" />}Check domain</button>
        </div>
      </div>
      {found && <div className="space-y-3 rounded-xl bg-[#f8f5ec] p-4" data-testid="domain-provider-step">
        <p className="text-sm flex items-center gap-1.5" data-testid="domain-available"><CheckCircle2 className="w-4 h-4 text-emerald-600" /><b>{found.root}</b> can be connected. Your website will open on <b data-testid="domain-detected-host">{found.hostname}</b>{found.apex && <> and {found.root}</>}.</p>
        <div>
          <p className="font-semibold text-[#062a20]">2. Where did you buy it?</p>
          {found.provider !== "other" && <p className="text-xs text-emerald-700">It looks like {found.provider_name} manages your domain. Change it if that's wrong.</p>}
          <div className="flex flex-wrap gap-2 mt-2" data-testid="domain-provider-list">
            {st.providers.map((x) => <button key={x.key} onClick={() => setProv(x.key)} className={`chip ${prov === x.key ? "!bg-[#0b3d2e] !text-[#f6ecd2] !border-[#0b3d2e]" : ""}`} data-testid={`domain-provider-${x.key}`}>{x.name}</button>)}
          </div>
        </div>
        <button disabled={busy} onClick={add} className="btn-emerald !py-2.5" data-testid="domain-add">{busy && <Loader2 className="w-4 h-4 animate-spin" />}Show my setup steps</button>
      </div>}
    </div>);
}
